import React, { Component } from 'react'

import Logo from './Logo'
import MainNav from './MainNav'
import SecondaryNav from './SecondaryNav'

export default class BaseHeader extends Component {

  render() {
    return (
      <header className="app-header vertical stretch fixed">
        <div className="header-row horizontal fixed header-primary horizontal">

          <Logo />

          <MainNav />

          <SecondaryNav />

        </div>
      </header>
    )
  }

}



// WEBPACK FOOTER //
// ./src/base/components/Header.js